import React, { useState } from 'react';
import styled from 'styled-components';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import WizardModal from '../kit/WizardModal';
import { TriggerKind } from '../wizardModel';
import { PrimaryButton, SecondaryButton, wz, wzType } from '../wizardStyles';
import ActionTiles from './ActionTiles';

const Question = styled.p`
  margin: 1px 0 24px;
  color: ${wz.text};
  font-weight: 700;
  ${wzType.question}
`;

interface IAddTriggerModalProps {
  title: string;
  addLabel: string;
  onAdd: (kind: TriggerKind) => void;
  onClose: () => void;
}

/** 6778:22346: the five actions again, picked for the next task (or Progress rule). */
const AddTriggerModal: React.FC<IAddTriggerModalProps> = ({ title, addLabel, onAdd, onClose }) => {
  const { t } = useMultiLanguageTranslation();
  const [kind, setKind] = useState<TriggerKind | null>(null);
  return (
    <WizardModal
      title={title}
      closeLabel={t(`${TOrbit}.wizard.tasks.cancel`)}
      onClose={onClose}
      footer={
        <>
          <SecondaryButton type="button" onClick={onClose}>
            {t(`${TOrbit}.wizard.tasks.cancel`)}
          </SecondaryButton>
          <PrimaryButton
            type="button"
            disabled={kind === null}
            onClick={() => kind !== null && onAdd(kind)}
          >
            {addLabel}
          </PrimaryButton>
        </>
      }
    >
      <Question>{t(`${TOrbit}.wizard.tasks.modalQuestion`)}</Question>
      <ActionTiles selected={kind} onSelect={setKind} columns={3} />
    </WizardModal>
  );
};

export default AddTriggerModal;
